//
// Generated class CoreItemList
//

/// <reference path="CoreItemList_ManagedObject.ts" />

class CoreItemList extends CoreItemList_ManagedObject
{

}
